export const USER_PAYROLL_SETTINGS_PATH = '/payroll-settings';
export const DEAL_PAYROLL_GROUP_SETTINGS_PATH = '/deal-payroll';

export const USER_PAYROLL_SETTINGS_RESUME_PATH = '/resume';



// WEBPACK FOOTER //
// C:/work/internal-frontend/src/app/services/deal-payroll-settings.service.constants.ts